import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import CreateQuiz from './CreateQuiz';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function EditQuiz({ user }) {
  const { quizId } = useParams();
  const [quizData, setQuizData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchQuiz = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/quizzes/${quizId}`);
        setQuizData(response.data);
      } catch (err) {
        console.error('Error fetching quiz:', err);
        setError('Error al cargar el quiz');
      } finally {
        setLoading(false);
      }
    };

    if (quizId) {
      fetchQuiz();
    }
  }, [quizId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          <p className="mt-4 text-gray-600">Cargando quiz...</p>
        </div>
      </div>
    );
  }

  if (error || !quizData) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="text-6xl mb-4">❌</div>
          <h3 className="text-xl font-semibold text-gray-700 mb-2">{error || 'Quiz no encontrado'}</h3>
        </div>
      </div>
    );
  }

  return <CreateQuiz user={user} existingQuiz={quizData} isEditMode={true} />;
}

export default EditQuiz;
